"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcxLogger = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const rollbar_1 = __importDefault(require("rollbar"));
class ArcxLogger {
    constructor(rollbarConfig) {
        this.rollbar = new rollbar_1.default(rollbarConfig);
        this.environment = rollbarConfig.environment;
    }
    setTestEnvironment() {
        this.environment = 'test';
        this.rollbar.configure({ environment: 'test' });
    }
    info(message, ...optionalParams) {
        this.report('info', message, optionalParams);
    }
    warning(message, ...optionalParams) {
        this.report('warning', message, optionalParams);
    }
    error(message, ...optionalParams) {
        this.report('error', message, optionalParams);
    }
    critical(message, ...optionalParams) {
        this.report('critical', message, optionalParams);
    }
    report(logLevel, message, optionalParams) {
        const rollbarFunctionMap = {
            info: () => this.rollbar.info(message, optionalParams),
            warning: () => this.rollbar.warning(message, optionalParams),
            error: () => this.rollbar.error(message, optionalParams),
            critical: () => this.rollbar.critical(message, optionalParams),
        };
        if (this.environment !== 'test') {
            if (optionalParams.length > 0) {
                console.log(`${logLevel.toUpperCase()}:`, message, ...optionalParams);
            }
            else {
                console.log(`${logLevel.toUpperCase()}:`, message);
            }
            rollbarFunctionMap[logLevel]();
        }
    }
}
exports.ArcxLogger = ArcxLogger;
//# sourceMappingURL=ArcxLogger.js.map